module.exports = __webpack_public_path__ + "files/ebefee20b925ba59dbf32a9e244ef19e.png";